import $ from 'jquery';

export const init = ($target) => {
	const $submitBtn = $('.global-form__inp-wrap input[type=submit]');
	$submitBtn.on('click', function () {
		$(this).addClass('btn is-disabled');
	});

	$target.ready(() => {
		scrollToErrorField();
	});

	function scrollToErrorField() {
		const $errorField = $('.field-validation-error').first().parent();

		if (!$errorField.length) {
			return;
		}

		const windowTop = $(window).scrollTop(),
			windowHeight = window.innerHeight,
			inputTop = $errorField.offset().top,
			inputBottom = $errorField.offset().top + $errorField.height();

		if (windowTop < inputTop) {
			return;
		}

		if (windowTop < inputBottom) {
			window.scrollTo(0, inputTop);
			return;
		}

		window.scrollTo(0, inputTop - windowHeight / 2);
		console.log('scrolling to');
	}
};
